import ReactGA from 'react-ga';
import * as CheckoutActionTypes from 'Types/CheckoutActionTypes';
import * as ShoppingCartActionTypes from 'Types/ShoppingCartActionTypes'
import * as GoogleAnalyticsActionTypes from 'Types/GoogleAnalyticsActionTypes';
import {StringIsEmpty} from 'Utilities/StringUtilities';
import { flattenShipmentProducts } from 'Utilities/ArrayUtilities';

const gaTrackingCode_production = 'UA-1304597-1';
const gaTrackingCode_staging = 'UA-1304597-10';
const gaTrackingCode_dev_qa = 'UA-1304597-12';

let gaTrackingCode;

switch (window.location.hostname) {
    case "www.speedwaymotors.com":
    case "test.speedwaymotors.com":
        gaTrackingCode = gaTrackingCode_production;
        break;
    case "staging.speedway2.com":
    case "staging-alt.speedway2.com":
        gaTrackingCode = gaTrackingCode_staging;
        break;
    case "qa.speedway2.com":
    case "qa-alt.speedway2.com":
        gaTrackingCode = gaTrackingCode_dev_qa;
        break;
    default:
        gaTrackingCode = gaTrackingCode_dev_qa;
        break;
}

if(!navigator.globalPrivacyControl && !document.cookie.includes('EnableGpc=')) {
    ReactGA.initialize(gaTrackingCode);
    ReactGA.plugin.require('ec');
}

let currentUrl = '';

const GoogleAnalyticsMiddlewareAction = (action, dispatch, getState) => {
    
    if(!navigator.globalPrivacyControl && !document.cookie.includes('EnableGpc=')) {
        try {
            switch (action.type) {
                case GoogleAnalyticsActionTypes.SEND_GOOGLE_ANALYTICS_EVENT:
                    if (action.payload.nonInteraction) {
                        ReactGA.event({
                            category: action.payload.category,
                            action: action.payload.action,
                            label: action.payload.label,
                            nonInteraction: true
                        })
                    } else {
                        ReactGA.event({
                            category: action.payload.category,
                            action: action.payload.action,
                            label: action.payload.label,
                        })
                    }
                    break;
                case CheckoutActionTypes.LOADED_CUSTOMER_INFO_STEP:
                    // a regular GA event has to be fired after an enhanced ecommerce event is fired
                    ReactGA.plugin.execute('ec', 'setAction', 'checkout', {
                        'step': 1
                    });
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Advanced to Info Step',
                        label: null,
                        nonInteraction: true
                    });
                    break;
                case CheckoutActionTypes.LOADED_SHIPPING_STEP:
                    // a regular GA event has to be fired after an enhanced ecommerce event is fired
                    ReactGA.plugin.execute('ec', 'setAction', 'checkout', {
                        'step': 2
                    });
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Advanced to Shipping Step',
                        label: action.transactionId,
                        nonInteraction: true
                    });
                    break;
                case CheckoutActionTypes.LOADED_CARB_MODAL:
                    break;
                case CheckoutActionTypes.CARB_ITEMS_REMOVED:
                    break;
                case CheckoutActionTypes.LOADED_PAYMENT_STEP:
                    // a regular GA event has to be fired after an enhanced ecommerce event is fired
                    ReactGA.plugin.execute('ec', 'setAction', 'checkout', {
                        'step': 3
                    });
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Advanced to Payment Step',
                        label: action.transactionId,
                        nonInteraction: true
                    });
                    break;
                case CheckoutActionTypes.LOADED_CONFIRMATION_STEP:
                    // a regular GA event has to be fired after an enhanced ecommerce event is fired
                    ReactGA.plugin.execute('ec', 'setAction', 'checkout', {
                        'step': 4
                    });
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Advanced to Confirm Step',
                        label: action.transaction.transactionId
                    });
                    break;
                case CheckoutActionTypes.REQUEST_SUBMIT_PAYPALEXPRESS:
                    ReactGA.event({
                        category: "Checkout",
                        action: 'Paypal Finalize Submit',
                        label: getState().transaction.transactionId
                    })
                    break;
                case CheckoutActionTypes.REQUEST_SUBMIT_BRAINTREE_PAYPALEXPRESS:
                    ReactGA.event({
                        category: "Checkout",
                        action: 'Paypal Finalize Submit',
                        label: getState().transaction.transactionId
                    })
                    break;
                case CheckoutActionTypes.REQUEST_SUBMIT_BRAINTREE_MOBILEPAY:
                    ReactGA.event({
                        category: "Checkout",
                        action: 'Mobile Pay Finalize Submit',
                        label: getState().transaction.transactionId
                    })
                    break;
                case CheckoutActionTypes.HYDRATED_CONFIRMATION_STEP:
                    flattenShipmentProducts(action.payload.checkoutTransactionRm).map(function (product) {
                        ReactGA.plugin.execute('ec', 'addProduct',
                            {
                                id: product.skuBase,
                                name: product.title,
                                category: product.category,
                                brand: product.brand,
                                variant: product.skuVariant,
                                price: product.price,
                                quantity: product.quantity,
                                productCategoryLevel1: product.category,
                                productCategoryLevel2: product.subcategory,
                                productCategoryLevel3: product.partType,
                                position: product.position
                            })
                    })

                    var coupons = undefined
                    if (action.payload.checkoutTransactionRm.paymentMethodContainer.promos.length) {
                        let promos = action.payload.checkoutTransactionRm.paymentMethodContainer.promos.map(promo => promo.promoCode).toString()

                        coupons = (!StringIsEmpty(promos)) ? promos : undefined
                    }

                    var orderNumber = action.payload.checkoutTransactionRm.confirmation.orderNumbers.length > 1
                        ? action.payload.checkoutTransactionRm.confirmation.masterOrderNumber
                        : action.payload.checkoutTransactionRm.confirmation.orderNumbers[0];

                    ReactGA.plugin.execute('ec', 'setAction', 'purchase', {
                        'id': orderNumber,
                        'revenue': action.payload.checkoutTransactionRm.confirmation !== null ? action.payload.checkoutTransactionRm.confirmation.orderSubTotal : 0,
                        'tax': action.payload.checkoutTransactionRm.confirmation !== null ? action.payload.checkoutTransactionRm.confirmation.taxTotal : 0,
                        'shipping': action.payload.checkoutTransactionRm.confirmation !== null ? action.payload.checkoutTransactionRm.confirmation.shippingTotal : 0,
                        //to be consistent, coupons needs to be set to undefined if there are none. this is how it was recorded in old checkout
                        'coupon': coupons
                    });

                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Transaction Completed',
                        label: orderNumber
                    });
                    break;
                case CheckoutActionTypes.SUBMIT_EMAIL_SIGN_UP:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Sign up for email on confirmation page'
                    })
                    break;
                case CheckoutActionTypes.ENABLE_ADDRESSBOOK:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Requested Address Book',
                        label: action.payload.transactionId
                    });
                    break;
                case CheckoutActionTypes.REQUEST_UPDATESHIPPINGADDRESS:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Updated Shipping Address',
                        label: action.payload
                    });
                    break;
                case CheckoutActionTypes.REQUEST_UPDATEADDRESSBOOK:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Edited Or Added A New Address',
                        label: JSON.stringify(action.payload)
                    });
                    break;
                case CheckoutActionTypes.REQUEST_SHIPPINGOPTION:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Changed Shipping Option',
                        label: action.payload
                    });
                    break;
                case CheckoutActionTypes.REQUEST_SHIPPINGMETHODSTEP:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Requested Shipment Page',
                        label: action.payload
                    })
                    break;
                case CheckoutActionTypes.REQUEST_PROMO_OR_GIFTCARD:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Attempted Promo Or Gift Card',
                        label: action.payload
                    });
                    break;
                case CheckoutActionTypes.RECEIVE_PROMO_OR_GIFTCARD:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Applied Promo Or Gift Card',
                        label: action.payload.checkoutTransactionRm.transactionId
                    });
                    break;
                case CheckoutActionTypes.REQUEST_REMOVEPROMO:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Removed Promo',
                        label: action.payload
                    });
                    break;
                case CheckoutActionTypes.REQUEST_REMOVEGIFTCARD:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Removed Gift Card',
                        label: action.payload
                    });
                    break;
                case CheckoutActionTypes.REQUEST_DEALERTERMS:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Attempted Dealer Terms Checkout',
                        label: action.payload
                    });
                    break;
                case CheckoutActionTypes.REQUEST_SUBMITPAYPALPAYMENT:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Chose PayPal as Payment Option',
                        label: action.payload
                    });
                    break;
                case CheckoutActionTypes.REQUEST_PAYMENTTECH_URL:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Requested Credit Card iFrame',
                        label: action.payload,
                        nonInteraction: true
                    });
                    break;
                case CheckoutActionTypes.REQUEST_REMOVE_CARB_ACKNOWLEDGE_ITEMS:
                    // a regular GA event has to be fired after an enhanced ecommerce event is fired
                    action.payload.items.forEach(function (carbItem) {
                        ReactGA.plugin.execute('ec', 'setAction', 'remove',
                            {
                                'id': carbItem.sku,
                                'name': carbItem.title,
                                'category': "remove carb acceptance of terms"
                            });

                        ReactGA.event({
                            category: 'Checkout',
                            action: 'Remove Carb Acknowledged Terms Item',
                            label: carbItem.sku
                        });
                    });
                    break;
                case CheckoutActionTypes.REQUEST_REMOVE_CARB_NO_SALE_ITEMS:
                    // a regular GA event has to be fired after an enhanced ecommerce event is fired
                    action.payload.items.forEach(function (carbItem) {
                        ReactGA.plugin.execute('ec', 'setAction', 'remove',
                            {
                                'sku': carbItem.sku,
                                'title': carbItem.title,
                                'category': "remove no sale carb item"
                            });

                        ReactGA.event({
                            category: 'Checkout',
                            action: 'Remove Carb No Sale Item',
                            label: carbItem.sku
                        });
                    });
                    break;
                case CheckoutActionTypes.REQUEST_REMOVE_DROPSHIP_ITEMS:
                    action.payload.dropshipItems.forEach(function (dropshipItem) {
                        ReactGA.plugin.execute('ec', 'setAction', 'remove',
                            {
                                'sku': dropshipItem.sku,
                                'title': dropshipItem.title,
                                'category': "remove PO box restricted dropship item"
                            });

                        ReactGA.event({
                            category: 'Checkout',
                            action: 'Remove PO Box Restricted Dropship item',
                            label: dropshipItem.sku
                        });
                    });
                    break;
                case CheckoutActionTypes.REQUEST_REMOVE_ITEMS:
                    action.payload.items.forEach(function (item) {
                        ReactGA.plugin.execute('ec', 'setAction', 'remove',
                            {
                                'sku': item.sku,
                                'title': item.title,
                                'reason': item.invalidReasonTitle
                            });
                        ReactGA.event({
                            category: 'Checkout',
                            action: item.invalidReasonTitle,
                            label: item.sku
                        });
                    });
                    break;
                case CheckoutActionTypes.REQUEST_REMOVE_TRUCK_FREIGHT_ITEMS:
                    action.payload.truckFreightItems.forEach(function (truckFreightItem) {
                        ReactGA.plugin.execute('ec', 'setAction', 'remove',
                            {
                                'sku': truckFreightItem.sku,
                                'title': truckFreightItem.title,
                                'category': "remove truck freight item"
                            });

                        ReactGA.event({
                            category: 'Checkout',
                            action: 'Remove truck freight item',
                            label: truckFreightItem.sku
                        });
                    });
                    break;
                case CheckoutActionTypes.RECEIVE_ADDRESS_SHIPPING_CONSTRAINT_MODAL:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Received Address Shipping Constraint Modal',
                        label: getState().transaction.transactionId
                    });
                    break;
                case CheckoutActionTypes.REQUEST_ACKNOWLEDGE_CARB_TERMS:
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Acknowledge Carb Terms',
                        label: getState().transaction.transactionId
                    });
                    break;
                case CheckoutActionTypes.RECEIVE_PAYPAL_EXPRESS:
                    // a regular GA event has to be fired after an enhanced ecommerce event is fired
                    ReactGA.plugin.execute('ec', 'setAction', 'checkout', {
                        'step': 2
                    });
                    ReactGA.plugin.execute('ec', 'setAction', 'checkout', {
                        'step': 3
                    });
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Advanced to PayPal Express Step',
                        label: action.payload.checkoutTransactionRm.transactionId,
                        nonInteraction: true
                    });
                    break;
                case CheckoutActionTypes.RECEIVE_MOBILE_PAY:
                    // a regular GA event has to be fired after an enhanced ecommerce event is fired
                    ReactGA.plugin.execute('ec', 'setAction', 'checkout', {
                        'step': 2
                    });
                    ReactGA.plugin.execute('ec', 'setAction', 'checkout', {
                        'step': 3
                    });
                    ReactGA.event({
                        category: 'Checkout',
                        action: 'Advanced to Mobile Payment Express Step',
                        label: action.payload.checkoutTransactionRm.transactionId,
                        nonInteraction: true
                    });
                    break;
                case GoogleAnalyticsActionTypes.SEND_PRODUCT_RECOMMENDATION_ENHANCED_IMPRESSION_EVENT:
                    action.payload.productRecommendations.forEach(function (productRecommendation) {
                        if (productRecommendation.isSkuBase) {
                            ReactGA.plugin.execute('ec', 'addImpression', {
                                'id': productRecommendation.skuBase,
                                'position': productRecommendation.ordinality,
                                'list': action.payload.variant,
                                'dimension1': 'SkuBase' // Custom dimension (string)
                            });
                        } else if (productRecommendation.IsSkuVariant) {
                            ReactGA.plugin.execute('ec', 'addImpression', {
                                'id': productRecommendation.skuVariant,
                                'position': productRecommendation.ordinality,
                                'list': action.payload.variant,
                                'dimension1': 'SkuVariant' // Custom dimension (string)
                            });
                        }
                    });
                    ReactGA.event({
                        category: 'Recommendations',
                        action: 'Loaded Product Recommendations',
                        label: action.payload.variant,
                        nonInteraction: true
                    });
                    break;
                case GoogleAnalyticsActionTypes.SEND_PRODUCT_RECOMMENDATION_ENHANCED_CLICK_EVENT:

                    if (action.payload.isSkuVariant) {
                        ReactGA.plugin.execute('ec', 'addProduct', {
                            'id': action.payload.sku,
                            'name': action.payload.title,
                            'position': action.payload.ordinality,
                            'list': action.payload.variant,
                            'price': action.payload.price,
                            'dimension1': 'SkuVariant' // Custom dimension (string)
                        });
                    } else {
                        ReactGA.plugin.execute('ec', 'addProduct', {
                            'id': action.payload.sku,
                            'name': action.payload.title,
                            'position': action.payload.ordinality,
                            'list': action.payload.variant,
                            'price': action.payload.price,
                            'dimension1': 'SkuBase' // Custom dimension (string)
                        });
                    }

                    ReactGA.plugin.execute('ec', 'setAction', 'click', {
                        'list': action.payload.variant
                    });

                    ReactGA.event({
                        category: 'Recommendations',
                        action: `${action.payload.page} - ${action.payload.recommendationsTitle} - Clicked Product`,
                        label: '' + action.payload.sku
                    });
                    ReactGA.event({
                        category: 'Recommendations',
                        action: `${action.payload.page} - ${action.payload.recommendationsTitle} - Clicked Product Ordinality`,
                        label: '' + action.payload.ordinality
                    });
                    ReactGA.event({
                        category: 'Recommendations',
                        action: `${action.payload.page} - ${action.payload.recommendationsTitle} - Clicked Product Label`,
                        label: action.payload.labelName
                    });
                    break;
                case GoogleAnalyticsActionTypes.SEND_PRODUCT_RECOMMENDATION_ENHANCED_ADD_TO_CART_EVENT:

                    if (action.payload.isSkuVariant) {
                        ReactGA.plugin.execute('ec', 'addProduct', {
                            'id': action.payload.sku,
                            'name': action.payload.title,
                            'position': action.payload.ordinality,
                            'list': action.payload.variant,
                            'price': action.payload.price,
                            'quantity': 1,
                            'dimension1': 'SkuVariant' // Custom dimension (string)
                        });
                    } else {
                        //this code is probably dead but I'm going to leave it just in case
                        ReactGA.plugin.execute('ec', 'addProduct', {
                            'id': action.payload.sku,
                            'name': action.payload.title,
                            'position': action.payload.ordinality,
                            'list': action.payload.variant,
                            'price': action.payload.price,
                            'quantity': 1,
                            'dimension1': 'SkuBase' // Custom dimension (string)
                        });
                    }

                    ReactGA.plugin.execute('ec', 'setAction', 'add', {
                        'list': action.payload.variant
                    });

                    ReactGA.event({
                        category: 'Recommendations',
                        action: `${action.payload.page} - ${action.payload.recommendationsTitle} - Added Product To Cart`,
                        label: '' + action.payload.sku
                    });
                    ReactGA.event({
                        category: 'Recommendations',
                        action: `${action.payload.page} - ${action.payload.recommendationsTitle} - Added Ordinality To Cart`,
                        label: '' + action.payload.ordinality
                    });
                    ReactGA.event({
                        category: 'Recommendations',
                        action: `${action.payload.page} - ${action.payload.recommendationsTitle} - Added Label To Cart`,
                        label: action.payload.labelName
                    });
                    break;
                case ShoppingCartActionTypes.RECEIVE_SHOPPINGCARTPAGE:
                    ReactGA.event({
                        category: 'Cart',
                        action: 'Received New Shopping Cart Page',
                        nonInteraction: true
                    })
                    break;

            }
        } catch (e) {
            console.error(e);
        }

        var gaBlacklist = ['isDevExperimentalCodeEnabled', 'isDealerTermsEnabled', 'simplifiedCartEnabled', 'isAccountCreateModalEnabled', 'splitUserKey', 'splitJavascriptApiKey', 'isFooterRedesignEnabled', 'isPaypalExpressDisabled', 'isEscapeModalEnabled', 'isStickySuperMarketInSearch', 'isGoogleReviewsEnabled', 'isInstorePickupShippingOptionEnabled', 'isEscapeModalEnabled', 'isNewPaypalComponentEnabled', 'isBraintreePaypalExpressEnabled', 'trustMarksEnabled', 'isNewAddressFormInPayPalExpressEnabled', 'shouldClearEventListenersOnSubmitPaymentButton', 'shouldAutoSubmitBraintreeAlternatePayment', 'isPaypalExpressMobilePayRouteEnabled', 'isFreeShippingFlagEnabled', 'showAvailabilityForKits', 'recommendationsMovedUpPageEnabled']

        //fire a ga event for each feature flag
        if (action.payload && action.payload.featureFlagContainer) {
            let featureFlagsStore = getState().featureFlagContainer
            let featureFlagsPayload = action.payload.featureFlagContainer

            //if the store has flags compare those to the payload to see which ones (if any) have changed, Else print out all of the new flags since the store was empty (initial client app load)
            if (Object.keys(featureFlagsStore).length) {
                Object.keys(featureFlagsPayload).forEach(function (flagPayload, index) {
                    if (featureFlagsStore[flagPayload] !== featureFlagsPayload[flagPayload]) {
                        //filter out flags we don't care about sending to GA
                        if (!gaBlacklist.includes(flagPayload)) {
                            ReactGA.event({
                                category: 'Feature Flag',
                                action: '' + flagPayload,
                                label: flagPayload + '-' + featureFlagsPayload[flagPayload],
                                nonInteraction: true
                            });
                        }
                    }
                })
            } else {
                Object.keys(featureFlagsPayload).forEach(function (flagPayload, index) {
                    //filter out flags we don't care about sending to GA
                    if (!gaBlacklist.includes(flagPayload)) {
                        ReactGA.event({
                            category: 'Feature Flag',
                            action: '' + flagPayload,
                            label: flagPayload + '-' + featureFlagsPayload[flagPayload],
                            nonInteraction: true
                        });
                    }
                })
            }
        }

        //pageviews
        try {
            let href = window.location.href

            //currently, the pageview is firing through gaEnhanced.js on the confirmation page
            //this will need to be changed when we redo the header
            if (href !== currentUrl && !href.includes('/Checkout/Confirmation')) {
                ReactGA.pageview(window.location.pathname);
                currentUrl = href;
            }
        } catch (e) {
            console.error(e);
        }
    }
}

export default GoogleAnalyticsMiddlewareAction;
